import { Fragment } from 'react';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_MINUTE, DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';

import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';
import { parseErknmValue } from '../common/parseErknmValue';

interface IErknmAct {
  passportData?: IKnmPreview;
}

export const ErknmAct = ({ passportData }: IErknmAct) => {
  return (
    <div className={styles.ColumnContent}>
      {passportData?.inspectionErknm?.organizations?.length && (
        <KnmSubtitle title="Сведения об акте">
          {passportData?.inspectionErknm?.organizations.map((item, index) => {
            return (
              item?.act && (
                <Fragment key={index}>
                  <span className={styles.SectionTitle}>Проверяемое лицо #{index + 1}</span>
                  {item.act.numberAct && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Номер акта КНМ</div>
                      <div className={styles.ColValue}>{item.act.numberAct}</div>
                    </div>
                  )}
                  {item.act.creationActDateTime && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Дата и время составления акта КНМ</div>
                      <div className={styles.ColValue}>
                        {formatDate({ date: item.act.creationActDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE })}
                      </div>
                    </div>
                  )}
                  {item.act.holdingDateTime && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Дата и время начала проведения КНМ</div>
                      <div className={styles.ColValue}>
                        {formatDate({ date: item.act.holdingDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE })}
                      </div>
                    </div>
                  )}
                  {item.act.durationDays && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Срок проведения (в днях)</div>
                      <div className={styles.ColValue}>{item.act.durationDays}</div>
                    </div>
                  )}
                  {item.act.durationHours && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Срок проведения (в часах)</div>
                      <div className={styles.ColValue}>{item.act.durationHours}</div>
                    </div>
                  )}
                  {typeof item.act.isViolationResolved === 'boolean' && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Факт устранения выявленного нарушения</div>
                      <div className={styles.ColValue}>{item.act.isViolationResolved ? 'Да' : 'Нет'}</div>
                    </div>
                  )}
                  {item.act.isViolationResolvedNote && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Сведения об устранении выявленного нарушения</div>
                      <div className={styles.ColValue}>{item.act.isViolationResolvedNote}</div>
                    </div>
                  )}
                  {item.act.noteInvalidate && (
                    <div className={styles.Row}>
                      <div className={styles.ColText}>Сведения о признании недействительными результатов КНМ</div>
                      <div className={styles.ColValue}>{item.act.noteInvalidate}</div>
                    </div>
                  )}
                </Fragment>
              )
            );
          })}
        </KnmSubtitle>
      )}
      {passportData?.inspectionErknm?.organizations?.length &&
        passportData?.inspectionErknm?.organizations.find(item => item?.act) && (
          <KnmSubtitle title="Нарушенные обязательные требования">
            {passportData?.inspectionErknm?.requirements?.length &&
            passportData?.inspectionErknm.requirements.find(item => item?.isObserved === false) ? (
              passportData?.inspectionErknm.requirements
                .filter(item => item?.isObserved === false)
                .map((item, index) => {
                  const requirementValue =
                    item.requirement && item.requirement.value
                      ? parseErknmValue<{ title?: string; nameNpa?: string; numberNpa?: string }>(
                          item.requirement.value,
                        )
                      : undefined;
                  return (
                    <Fragment key={index}>
                      <span className={styles.SectionTitle}>Обязательное требование #{index + 1}</span>
                      {requirementValue?.title && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Формулировка требования</div>
                          <div className={styles.ColValue}>{requirementValue.title}</div>
                        </div>
                      )}
                      {requirementValue?.nameNpa && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Наименование НПА</div>
                          <div className={styles.ColValue}>{requirementValue.nameNpa}</div>
                        </div>
                      )}
                      {requirementValue?.numberNpa && (
                        <div className={styles.Row}>
                          <div className={styles.ColText}>Дата НПА</div>
                          <div className={styles.ColValue}>
                            {formatDate({ date: requirementValue.numberNpa, dateFormat: DATE_FORMAT_LONG })}
                          </div>
                        </div>
                      )}
                    </Fragment>
                  );
                })
            ) : (
              <div className={styles.Row}>
                <span className={styles.ColText}>Нарушенные обязательные требования отсутствуют</span>
              </div>
            )}
          </KnmSubtitle>
        )}
    </div>
  );
};
